/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-local-attraction__chart[_ngcontent-%COMP%]{height:500px}.edit-local-attraction__wideField[_ngcontent-%COMP%]{width:90%}.edit-local-attraction__button-spacing[_ngcontent-%COMP%]{margin-bottom:10px;margin-top:10px}legend[_ngcontent-%COMP%]{color:#00a3e0}.fieldset-container[_ngcontent-%COMP%]{margin-bottom:20px;padding-top:20px}"];
export { styles as styles };
